export const JOURNEY = "journey";
export const GET_JOURNEY = "get_journey";
export const GET_JOURNEY_TRAVELLED = 'GET_JOURNEY_TRAVELLED';
export const GET_JOURNEY_TRAVELLED_BY_FILTER = 'GET_JOURNEY_TRAVELLED_BY_FILTER';